import { Headline, HeadlineProps } from '@almbrand/headline';

export interface HeadlineComponentProps extends Omit<HeadlineProps, 'variant'> {
	heading: 'h1' | 'h2' | 'h3' | 'h4';
}

export const HeadlineComponent: React.FC<HeadlineComponentProps> = ({ heading, ...props }) => {
	return (
		<Headline
			{...props}
			variant={heading}
		/>
	);
};
